import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import CookieConsent from "@/components/CookieConsent";

import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";

import Home from "@/pages/Home";
import Tours from "@/pages/Tours";
import TourDetail from "@/pages/TourDetail";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function RobotsMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isPrivateRoute = pathname.startsWith("/admin") || pathname.startsWith("/auth");
    const existing = document.querySelector('meta[name="robots"]');
    if (!isPrivateRoute) {
      existing?.remove();
      return;
    }
    const tag = existing || document.createElement("meta");
    tag.setAttribute("name", "robots");
    tag.setAttribute("content", "noindex, nofollow");
    if (!existing) document.head.appendChild(tag);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}

function AdminLayout({ children }) {
  return <main>{children}</main>;
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <ScrollToTop />
          <RobotsMeta />
          <Routes>
            <Route path="/admin/login" element={<AdminLayout><Login /></AdminLayout>} />
            <Route path="/admin" element={<AdminLayout><Admin /></AdminLayout>} />

            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/tours" element={<PublicLayout><Tours /></PublicLayout>} />
            <Route path="/tours/:slug" element={<PublicLayout><TourDetail /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/stories" element={<PublicLayout><Blog /></PublicLayout>} />
            <Route path="/stories/:slug" element={<PublicLayout><BlogDetail /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
            <Route path="*" element={<PublicLayout><Home /></PublicLayout>} />
          </Routes>
          <CookieConsent />
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
